// extracted by mini-css-extract-plugin
export default {"captcha":"Captcha_captcha__YEk4HglS","error":"Captcha_error__cUwlO5+e"};